
define('error',['jquery', 'bootbox'], function ($, bootbox) {
    $.ajaxSetup({           //default error function for ajax calls.  If they implement a local error function then it will override this one.
        error: function (xhr) { 
            if (xhr.status === 403) {
                var response = $.parseJSON(xhr.responseText);       //AuthorizeAttribute.cs returns json error object that we need to parse here.
                bootbox.alert("An error occurred: " + xhr.status + " Error: " + response.Error);
            } else if (xhr.status === 404) {
                bootbox.alert("404 - Resource not found.  Please contact system administrator: " + xhr.responseText);
            }
            else if (xhr.status === 500) {
                if (xhr && xhr.responseText && xhr.responseText.length > 0)
                    bootbox.alert("500 - Internal Server Error.  Please contact system administrator: " + xhr.responseText);
                else
                    bootbox.alert("500 - Internal Server Error.  Please contact system administrator.");
            }
            else {
                if (xhr.status != 0) {
                    bootbox.alert("An error occurred: " + xhr.status + "nError: " + xhr.responseText);
                }
            }

            $.ajax({
                type: "POST",
                url: "/Error/Log",
                data: { error: "Ajax Error code: " + xhr.status, fullMessage: "Ajax Response text: " + xhr.responseText }
            });
        }
    });
});
